import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { id: "main" }
const _hoisted_2 = {
  key: 0,
  class: "message-box"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DirectLinks = _resolveComponent("DirectLinks")!
  const _component_SearchBox = _resolveComponent("SearchBox")!
  const _component_FavoriteBox = _resolveComponent("FavoriteBox")!
  const _component_SideBar = _resolveComponent("SideBar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { id: "wallpaper" }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        id: "logo",
        ref: "logo",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleFavrotite && _ctx.toggleFavrotite(...args)))
      }, null, 512),
      _createVNode(_component_DirectLinks, {
        ref: "directLinks",
        tabAsync: _ctx.tabAsync,
        onShowEditBox: _ctx.showEditBox,
        onShowMessage: _ctx.showMessage,
        onUploadSyncData: _ctx.uploadSyncData
      }, null, 8, ["tabAsync", "onShowEditBox", "onShowMessage", "onUploadSyncData"]),
      _createVNode(_component_SearchBox, {
        searchInputFocused: _ctx.searchInputFocused,
        onSearchInputFocus: _ctx.searchInputFocus,
        onEngineChanged: _ctx.changeEngineLogo
      }, null, 8, ["searchInputFocused", "onSearchInputFocus", "onEngineChanged"]),
      _withDirectives(_createVNode(_component_FavoriteBox, {
        ref: "favoriteBox",
        tabAsync: _ctx.tabAsync,
        onUploadSyncData: _ctx.uploadSyncData,
        onDownloadSyncData: _ctx.downloadSyncData,
        onShowMessage: _ctx.showMessage,
        onShowEditBox: _ctx.showEditBox,
        onToggleVisbility: _ctx.toggleFavrotite
      }, null, 8, ["tabAsync", "onUploadSyncData", "onDownloadSyncData", "onShowMessage", "onShowEditBox", "onToggleVisbility"]), [
        [_vShow, _ctx.showFavorite]
      ]),
      _createVNode(_component_SideBar, {
        ref: "sideBar",
        tabAsync: _ctx.tabAsync,
        syncStatus: _ctx.syncStatus,
        searchInputFocused: _ctx.searchInputFocused,
        onUploadSyncData: _ctx.uploadSyncData,
        onShowMessage: _ctx.showMessage,
        onShowEditBox: _ctx.showEditBox
      }, null, 8, ["tabAsync", "syncStatus", "searchInputFocused", "onUploadSyncData", "onShowMessage", "onShowEditBox"])
    ]),
    (_ctx.messages.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (msg) => {
            return (_openBlock(), _createElementBlock("div", {
              key: msg.id,
              style: _normalizeStyle({'background-color': msg.color})
            }, _toDisplayString(msg.content), 5))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}